/* eslint-disable no-new */
/* eslint-disable no-undef */
import Slider from './Slider';

new Vue({
  el: '#amp-ca-slider',
  render(h) {
    return h(Slider, {
      props: {
        content: (this.$el.attributes['data-content'] && this.$el.attributes['data-content'].value.length > 0 ? this.$el.attributes['data-content'].value : 'DEFAULT'),
        sliderHash: Math.random().toString(36).substring(2, 15) // this hash is used to create a unique classname for each slider to meet the requirements of the tiny slider library.
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/components/slider/slider-instance.js